export default __webpack_public_path__ + "static/media/thumbnail.c4179eee.png";